import {breakpoints} from "@next/ux-fabric"

declare global {
    export interface Window {
        appInsights?: any
        platmodflags?: any
        NextFavourites?: any
    }
}

export const IS_BROWSER = () => typeof window !== "undefined"

export function getWindow() {
    return IS_BROWSER() ? window : null
}

export const screenIsSmallerThanLarge = () => (IS_BROWSER() ? window.innerWidth < breakpoints.values.lg : false)
export const screenIsBiggerOrEqualToLarge = () => (IS_BROWSER() ? window.innerWidth >= breakpoints.values.lg : false)

export default getWindow
